import { View } from "@react-pdf/renderer";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import {
  ResumePDFSection,
  ResumePDFText,
} from "components/Resume/ResumePDF/common";
import type { ResumeProfile } from "lib/redux/types";

export const Profile = ({
  profile,
  themeColor,
  isPDF,
}: {
  profile: ResumeProfile;
  themeColor: string;
  isPDF: boolean;
}) => {
  const { name, email, phone, url1, url2, summary, location } = profile;
  const initial = name.charAt(0).toUpperCase();

  return (
    <ResumePDFSection>
      <View
        style={{
          ...styles.flexCol,
          flexDirection: "column",
          justifyContent: "flex-end",
          alignItems: "flex-end",
          marginBottom: spacing["2"],
        }}
      >
        <View
          style={{
            width: "90pt",
            height: "90pt",
            backgroundColor: "black",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: spacing["1"],
            ...styles.flexRow,
          }}
        >
          <ResumePDFText
            bold={true}
            themeColor={themeColor}
            style={{
              fontSize: spacing[24],

              textAlign: "center",
            }}
          >
            {initial}
          </ResumePDFText>
        </View>

        <ResumePDFText
          bold={true}
          themeColor={themeColor}
          style={{
            ...styles.flexCol,
            fontSize: "25pt",
            textAlign: "right",
          }}
        >
          {name}
        </ResumePDFText>
      </View>
    </ResumePDFSection>
  );
};
